import { keyExists } from '../../../../utils';
import { isConjunction, isSpace, allEmpty, fieldAndOperator, onlyField, onlyValue, } from './termUtils';
const defaultOperators = [
    { label: ':', value: ':', description: 'equal to' },
];
const defaultConjunctions = [
    { label: 'AND', value: 'AND ', description: '' },
    { label: 'OR', value: 'OR ', description: '' },
];
function filterOnLabel(value) {
    return (s) => s.label.toLowerCase().startsWith(value.toLowerCase());
}
function filterAndSort(s, x) {
    if (x) {
        return s.filter(filterOnLabel(x.toString()));
    }
    return s;
}
export function getSuggestionList(lastTerm, suggestionLookup) {
    const { term, isFirstTerm } = lastTerm;
    const { defaults, fields, operators, staticValues, disableConjunctions } = suggestionLookup;
    if (allEmpty(term)) {
        return defaults;
    }
    if (onlyValue(term)) {
        if (isSpace(term.value.toString())) {
            return defaults;
        }
        if (!isFirstTerm && !disableConjunctions) {
            return filterAndSort([...fields, ...defaultConjunctions], term.value.toString());
        }
        return filterAndSort(fields, term.value.toString());
    }
    if (fieldAndOperator(term) && keyExists(staticValues, term.field)) {
        return filterAndSort(staticValues[term.field], term.value);
    }
    if (onlyField(term)) {
        if (isConjunction(term.field)) {
            return defaults;
        }
        return operators[term.field] || defaultOperators;
    }
    return [];
}
